import { SettingsLayout } from 'modules/settingsContainer/SettingsLayout';
import { DataTab } from 'modules/visualisations/Bubble/settings/DataTab';
import { ViewTab } from 'modules/visualisations/Bubble/settings/ViewTab';

export const BubbleMainSettings = () => {
  return <SettingsLayout DataComponent={DataTab} ViewComponent={ViewTab} />;
};
